import React from "react";
import { useEffect } from "react";
import { DesktopCourseNav } from "./small-course-nav/desktop-course-nav";
import { MobileCourseNav } from "./mobile-course-nav/mobile-course-nav";
import MyCoursesNav from "./my-course-nav/my-courses-nav";
import SearchCoursesNav from "./search-course-nav/search-courses-nav";
import { usePleaseLoginInfo } from "../../../hooks/use-please-login-info";
import { useChatStore } from "../../../store/chatStore";
import { useStore } from "../../../store/store";

export default function CourseNav({
  showContentNav,
  makeGroupVisibleInCourses,
  setMakeGroupVisibleInCourses,
  visibleCourses,
  setVisibleCourses,
  props,
}) {
  // Use centralized stores for state management
  const { isMyCoursesOpen, isSearchCoursesOpen, setIsMyCoursesOpen, setIsSearchCoursesOpen } = useStore();
  const { isChatOpen, setIsChatOpen } = useChatStore();

  const { openPleaseLoginInfo } = usePleaseLoginInfo();

  useEffect(() => {
    if (makeGroupVisibleInCourses) {
      toggleSearchNav();
    }
  }, [makeGroupVisibleInCourses]);

  const isLoggedIn = Boolean(localStorage.getItem("token"));

  const toggleMyCourses = () => {
    if (!isLoggedIn) {
      openPleaseLoginInfo();
      return;
    }

    setIsMyCoursesOpen(!isMyCoursesOpen);
  };
  const toggleSearchNav = () => {
    if (makeGroupVisibleInCourses) {
      setIsSearchCoursesOpen(!isSearchCoursesOpen);
    }
  };
  const toggleSearchCourses = () => {
    setIsSearchCoursesOpen(!isSearchCoursesOpen);
  };
  const toggleMobileChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  if (!isMyCoursesOpen && !isSearchCoursesOpen) {
    return (
      <>
        <DesktopCourseNav
          showContentNav={showContentNav}
          toggleMyCourses={toggleMyCourses}
          toggleSearchCourses={toggleSearchCourses}
          props={props}
        />
        <MobileCourseNav
          toggleMyCourses={toggleMyCourses}
          toggleSearchCourses={toggleSearchCourses}
          toggleMobileChat={toggleMobileChat}
        />
      </>
    );
  }

  if (isMyCoursesOpen && !isSearchCoursesOpen) {
    return <MyCoursesNav toggle={toggleMyCourses} props={props} />;
  }

  if (isSearchCoursesOpen) {
    return (
      <SearchCoursesNav
        escapeToggle={toggleSearchCourses}
        props={props}
        makeGroupVisibleInCourses={makeGroupVisibleInCourses}
        visibleCourses={visibleCourses}
        setMakeGroupVisibleInCourses={setMakeGroupVisibleInCourses}
        setVisibleCourses={setVisibleCourses}
      />
    );
  }
}
